import { render, staticRenderFns } from "./MarketingFormSendersCustomList.vue?vue&type=template&id=70b5a70e&scoped=true"
import script from "./MarketingFormSendersCustomList.vue?vue&type=script&lang=js"
export * from "./MarketingFormSendersCustomList.vue?vue&type=script&lang=js"
import style0 from "./MarketingFormSendersCustomList.vue?vue&type=style&index=0&id=70b5a70e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5a70e",
  null
  
)

export default component.exports